import { Configuration, PaymentsApi } from '@/api';
import { listPaymentMethodsQueryKey } from '@/api/queries/useListPaymentMethodsQuery';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function useDeletePaymentMethodMutation() {
  const queryClient = useQueryClient();
  const auth = useAuth();
  const api = new PaymentsApi(new Configuration(auth));

  return useMutation({
    mutationFn: async (id: string) => {
      await api.deletePaymentMethod(id);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: listPaymentMethodsQueryKey });
    },
  });
}
